import React from "react";
import { Avatar } from "antd";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { isManufacturer } from "../../util/helper";
import { useSelector } from "react-redux";

const ProductCardDesign = ({ testimonial }) => {
  const history = useHistory();
  const { primaryImage, name, specification, hscode, id, isFromUserProfile } =
    testimonial;
  const authUser = useSelector(({ auth }) => auth.userData);

  return (
    <div
      className="product-card"
      onClick={() => {
        history.push(`my-products/details?id=${id}`, {
          isFromUserProfile: isFromUserProfile ?? true,
        });
      }}
    >
      <Avatar src={primaryImage} alt="..." />
      <div className="gx-p-3">
        <div className="hsn gx-pb-1">
          {`HSN :`} <span>{hscode?.code}</span>
        </div>
        <div className="name gx-pb-1">{name}</div>
        {!isManufacturer(authUser) && isFromUserProfile && (
          <div className="content">{specification}</div>
        )}
      </div>
    </div>
  );
};

export default ProductCardDesign;
